<template>
  <Layout>
    <PageHeader :title="title" :items="braedcrumb" />
    <div>
      <b-row>
        <b-col>
          <b-card>
            <b-row>
              <b-col sm="12" md="4">
                <div>
                  <label>{{ $t("headertext") }}</label>
                  <b-input-group>
                    <b-form-textarea
                      :placeholder="$t('headertext')"
                      v-model="Regulations.headertext"
                      type="text"
                    ></b-form-textarea>
                    <b-input-group-append>
                      <b-button
                        style="min-height:60px;min-width:50px"
                        @click="translate('headertext')"
                        variant="outline-info"
                        ><i class="bx bx-globe iconStyle"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <!-- <b-form-textarea
                    :placeholder="$t('headertext')"
                    v-model="Regulations.headertext"
                    type="text"
                  ></b-form-textarea> -->
                </div>
              </b-col>
              <b-col sm="12" md="4">
                <div>
                  <label>{{ $t("text") }}</label>
                  <b-input-group>
                    <b-form-textarea
                      :placeholder="$t('text')"
                      v-model="Regulations.text"
                      type="text"
                    ></b-form-textarea>
                    <b-input-group-append>
                      <b-button
                        style="min-height:60px;min-width:50px"
                        @click="translate('text')"
                        variant="outline-info"
                        ><i class="bx bx-globe iconStyle"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <!-- <b-form-textarea
                    :placeholder="$t('text')"
                    v-model="Regulations.text"
                    type="text"
                  ></b-form-textarea> -->
                </div>
              </b-col>
              <b-col sm="12" md="4">
                <div>
                  <label>{{ $t("ordercode") }}</label>
                  <b-form-input
                    :placeholder="$t('ordercode')"
                    v-model="Regulations.ordercode"
                    type="text"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="12" md="4">
                <div>
                  <label for>{{ $t("parent") }}</label>
                  <div>
                    <v-select
                      :options="RegulationsList"
                      :reduce="(item) => item.id"
                      :placeholder="$t('ChooseBelow')"
                      label="headertext"
                      v-model="Regulations.parentid"
                    ></v-select>
                  </div>
                </div>
              </b-col>
              <b-col sm="12" md="4">
                <div>
                  <label for>{{ $t("state") }}</label>
                  <div>
                    <v-select
                      :options="StateList"
                      :reduce="(item) => item.id"
                      :placeholder="$t('ChooseBelow')"
                      label="name"
                      v-model="Regulations.stateid"
                    ></v-select>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-tabs pills>
            <b-tab :title="$t('main')">
              <b-card>
                <tinymce
                  id="d1"
                  v-model="Regulations.maintext"
                  :plugins="plugins"
                  :toolbar="toolbar"
                  :other_options="options"
                ></tinymce>
              </b-card>
            </b-tab>
            <b-tab @click="translateTab('maintext')" :title="$t('translate')">
              <b-card>
                <!-- <b-row class="m-2 mt-2">
                  <b-col class="text-right" style="text-align:right">
                    <b-button
                      class="m-2"
                      @click="translatemodal = false"
                      size="sm"
                      variant="outline-danger"
                    >
                      <i class="dripicons-arrow-thin-left"></i>
                      {{ $t("back") }}
                    </b-button>
                    <b-button
                      class="m-2"
                      @click="SaveTranslateTab"
                      size="sm"
                      variant="outline-success"
                    >
                      <i class="dripicons-checkmark"></i>
                      {{ $t("Save") }}
                    </b-button>
                  </b-col>
                </b-row> -->
                <b-table
                  :fields="translitefields"
                  :items="translatelistTab"
                  head-variant="primary"
                  class="text-center"
                  style="vertical-align:middle"
                  bordered
                  responsive="sm"
                >
                  <template v-slot:thead-top>
                    <b-tr>
                      <b-th style="width:20%">
                        <v-select
                          :options="LanguageList"
                          :reduce="(item) => item.id"
                          :placeholder="$t('ChooseBelow')"
                          label="fullname"
                          v-model="translaterow.languageid"
                        ></v-select>
                      </b-th>
                      <b-th>
                        <tinymce
                          id="d2"
                          v-model="translaterow.translatetext"
                          :plugins="plugins"
                          :toolbar="toolbar"
                          :other_options="options"
                        ></tinymce>
                      </b-th>
                      <b-th style="width:10%">
                        <b-button
                          @click="addtransliteTab"
                          color="primary"
                          variant="outline-primary"
                        >
                          <i class="bx bx-plus"> </i>
                        </b-button>
                      </b-th>
                    </b-tr>
                  </template>
                  <template v-slot:cell(translatetext)="{ item }">
                    <b-form-input
                      v-model="item.translatetext"
                      class="mb-0"
                    ></b-form-input>
                  </template>
                </b-table>
              </b-card>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
      <b-modal
        size="xl"
        :title="$t('translate')"
        v-model="translatemodal"
        no-close-on-backdrop
        hide-footer
      >
        <b-row>
          <b-col>
            <b-table
              :fields="translitefields"
              :items="translatelist"
              head-variant="primary"
              class="text-center"
              style="vertical-align:middle"
              bordered
              responsive="sm"
            >
              <template v-slot:thead-top>
                <b-tr>
                  <b-th style="width:30%">
                    <v-select
                      :options="LanguageList"
                      :reduce="(item) => item.id"
                      :placeholder="$t('ChooseBelow')"
                      label="fullname"
                      v-model="translaterow.languageid"
                    ></v-select>
                  </b-th>
                  <b-th style="width:60%">
                    <b-form-textarea v-model="translaterow.translatetext">
                    </b-form-textarea>
                  </b-th>
                  <b-th style="width:10%">
                    <b-button
                      @click="addtranslite"
                      color="primary"
                      variant="outline-primary"
                    >
                      <i class="bx bx-plus"> </i>
                    </b-button>
                  </b-th>
                </b-tr>
              </template>
              <template v-slot:cell(translatetext)="{ item }">
                <b-form-input
                  v-model="item.translatetext"
                  class="mb-0"
                ></b-form-input>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row class="m-2 mt-2">
          <b-col class="text-center">
            <b-button
              class="m-2"
              @click="translatemodal = false"
              size="sm"
              variant="outline-danger"
            >
              <i class="dripicons-arrow-thin-left"></i>
              {{ $t("back") }}
            </b-button>
            <b-button
              class="m-2"
              @click="SaveTranslate"
              size="sm"
              variant="outline-success"
            >
              <i class="dripicons-checkmark"></i>
              {{ $t("Save") }}
            </b-button>
          </b-col>
        </b-row>
      </b-modal>
      <!-- <b-row>
        <b-col sm="12" md="12" lg="12">
          <b-card>
            <b-row>
              <b-col
                cols="12"
                class="text-right mb-2"
                style="text-align:end !important"
              >
                <b-button @click="OpenModal" size="sm" variant="primary">
                  <i class="bx bx-plus"></i>
                  {{ $t("Add") }}
                </b-button>
              </b-col>
            </b-row>
            <b-table
              :fields="fields"
              bordered
              responsive
              :busy="isLoading"
              head-row-variant="info"
              sticky-header="60vh"
              no-border-collapse
              striped
              small
              :items="Regulations.Tables"
              class="text-center"
              :tbody-tr-class="rowClass"
            >
              <template #cell(actions)="{ item }">
                <div class="text-center">
                  <b-link>
                    <i
                      style="margin-right: 5px"
                      @click="Edit(item)"
                      class="bx bx-pencil"
                    ></i>
                  </b-link>
                  <b-link>
                    <i @click="DeleteRow(item)" class="bx bx-trash-alt"></i>
                  </b-link>
                </div>
              </template>
            </b-table>
          </b-card>
        </b-col>
      </b-row> -->
      <b-modal
        size="lg"
        v-model="ModalShow"
        no-close-on-backdrop
        hide-footer
        :title="$t('Tables')"
      >
        <!-- <div class="form-group form-row m-2">
          <label class="col-form-label col-sm-5" for>{{ $t("header") }}</label>
          <div class="col-sm-7">
            <b-form-input :placeholder="$t('header')" v-model="tabrow.header" />
          </div>
        </div> -->

        <div class="form-group form-row m-2">
          <label class="col-form-label col-sm-5" for>{{ $t("text") }}</label>
          <div class="col-sm-7">
            <b-form-input :placeholder="$t('text')" v-model="tabrow.text" />
          </div>
        </div>
        <b-row class="m-2 mt-2">
          <b-col class="text-center">
            <b-button
              class="m-2"
              @click="ModalShow = false"
              size="sm"
              variant="outline-danger"
            >
              <i class="dripicons-arrow-thin-left"></i>
              {{ $t("back") }}
            </b-button>
            <b-button
              class="m-2"
              @click="AddRow"
              size="sm"
              variant="outline-success"
            >
              <i class="dripicons-checkmark"></i>
              {{ $t("Save") }}
            </b-button>
          </b-col>
        </b-row>
      </b-modal>
      <b-row>
        <b-col>
          <b-card>
            <b-row>
              <b-col class="text-right">
                <b-button
                  @click="$router.push('/info/Regulations')"
                  class="d-inline-block "
                  variant="danger"
                  ><i class="dripicons-arrow-thin-left"></i>
                  {{ $t("back") }}</b-button
                >
              </b-col>
              <b-col style="text-align: right !important; " class="text-right">
                <b-button
                  @click="SaveData"
                  class="d-inline-block "
                  variant="success"
                  ><i class="dripicons-checkmark"></i>
                  {{ $t("save") }}</b-button
                >
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </Layout>
</template>
<script>
import vSelect from "vue-select";
import DatePicker from "vue2-datepicker";
import Layout from "../../../router/layouts/main.vue";
import PageHeader from "@/components/page-header";
import RegulationsService from "@/services/info/Regulations.service";
import HelperService from "@/services/others/helper.service";
import Multiselect from "vue-multiselect";
import appConfig from "@/app.config";
export default {
  page: {
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Multiselect,
    Layout,
    PageHeader,
    DatePicker,
    vSelect,
  },
  data() {
    return {
      title: this.$t("Regulations"),
      braedcrumb: [
        {
          text: this.$t("Info"),
        },
        {
          text: this.$t("Regulations"),
          active: true,
        },
      ],
      content: "<h1>Some initial content</h1>",

      plugins: [
        "advlist autolink link image lists charmap print preview hr anchor pagebreak spellchecker",
        "searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking",
        "save table contextmenu directionality emoticons template paste textcolor",
      ],
      options: {
        height: 300,
        style_formats: [
          { title: "Bold text", inline: "b" },
          { title: "Red text", inline: "span", styles: { color: "#ff0000" } },
          { title: "Red header", block: "h1", styles: { color: "#ff0000" } },
          { title: "Example 1", inline: "span", classes: "example1" },
          { title: "Example 2", inline: "span", classes: "example2" },
          { title: "Table styles" },
          { title: "Table row 1", selector: "tr", classes: "tablerow1" },
        ],
      },
      toolbar:
        "insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | l      ink image | print preview media fullpage | forecolor backcolor emoticons",
      items: [],
      // //  show: false,
      Regulations: { TranslatableColumns: [] },
      translatemodal: false,
      translitefields: [
        {
          key: "languagename",
          label: this.$t("languagename"),
          variant: "info",
        },
        { key: "translatetext", label: this.$t("name"), variant: "info" },
        { key: "actions", label: "", variant: "info" },
      ],
      translatelist: [],
      translatelistTab: [],
      translaterow: {
        tableid: 0,
        tablerowid: 0,
        languageid: 0,
        languagename: "",
        columnname: "",
        translatetext: "",
      },
      translatebyname: "",
      isLoading: false,
      selected: {},
      filter: {
        OnDate: "",
        DepartmentID: 0,
        HREmpAppointOrderTypeID: 0,
        Search: "",
        SortColumn: "",
        OrderType: "asc",
        PageNumber: 1,
        PageLimit: 20,
        isTeacher: true,
        oblastid: 0,
        regionid: 0,
        isfarmfy: false,
      },
      fields: [
        // {
        //   key: "header",
        //   label: this.$t("header"),
        //   thClass: "text-center",
        //   sortable: true,
        // },
        {
          key: "text",
          label: this.$t("text"),
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "actions",
          label: this.$t("actions"),
          thClass: "text-center",
          sortable: true,
        },
      ],
      tabrow: {
        id: 0,
        ownerid: 0,
        text: "",
        Status: 1,
      },
      RegulationsList: [],
      LanguageList: [],
      ModalShow: false,
      StateList: [],
      editedIndex1: -1,
      lang: "ru",
    };
  },
  created() {
    this.lang = localStorage.getItem("locale") || "ru";
    this.show = true;
    HelperService.GetStateList().then((res) => {
      this.StateList = res.data;
    });
    HelperService.GetListLanguages().then((res) => {
      this.LanguageList = res.data;
    });
    RegulationsService.GetAll(this.lang).then((res) => {
      this.RegulationsList = res.data;
    });
    RegulationsService.Get(this.$route.params.id)
      .then((res) => {
        this.show = false;
        this.Regulations = res.data;
        this.translatelist = res.data.Translates;
        this.translatelistTab = res.data.Translates;
        // this.Regulations.parentid = null;
      })
      .catch((error) => {
        this.$notification(error.response.data.error, "danger");
      });
  },
  directives: {},
  methods: {
    // ChangeParent() {
    //   this.Regulations.headertext = this.RegulationsList.filter(
    //     (item) => this.Regulations.parentid === item.id
    //   )[0].headertext;
    // },
    translate(selectcolumnname) {
      var self = this;
      self.translatebyname = selectcolumnname;
      self.translatelist = self.Regulations.Translates.filter(
        (item) => item.columnname == selectcolumnname
      );
      // if (self.translatebyname != "maintext") {
      self.translatemodal = true;
      // }
    },
    translateTab(selectcolumnname) {
      var self = this;
      self.translatebyname = selectcolumnname;
      self.translatelistTab = self.Regulations.Translates.filter(
        (item) => item.columnname == selectcolumnname
      );
      // if (self.translatebyname != "maintext") {
      // self.translatemodal = true;
      // }
    },
    addtranslite() {
      var self = this;
      if (
        self.translaterow.languageid === 0 ||
        self.translaterow.languageid === undefined ||
        self.translaterow.languageid === null
      ) {
        this.$notification(
          this.$t("languageidNotSelect"),
          this.$t("Error"),
          "danger"
        );
      } else if (
        self.translaterow.translatetext === "" ||
        self.translaterow.translatetext === undefined ||
        self.translaterow.translatetext === null
      ) {
        this.$notification(
          this.$t("translatetextNotSelect"),
          this.$t("Error"),
          "danger"
        );
      } else {
        var dublikate = false;
        self.translatelist.forEach((item) => {
          if (item.languageid === self.translaterow.languageid) {
            this.$notification(
              this.$t("dublikate"),
              this.$t("Error"),
              "danger"
            );
            dublikate = true;
          }
        });
        if (!dublikate) {
          self.translaterow.languagename = self.LanguageList.filter(
            (item) => item.id === self.translaterow.languageid
          )[0].fullname;
          self.translaterow.columnname = self.translatebyname;
          self.translatelist.push(self.translaterow);
          self.translaterow = {
            tableid: 0,
            tablerowid: 0,
            languageid: 0,
            languagename: "",
            columnname: "",
            translatetext: "",
          };
        }
      }
    },
    SaveTranslate() {
      var self = this;
      self.Regulations.Translates = self.Regulations.Translates.filter(
        (x) => x.columnname !== self.translatebyname
      );
      self.translatelist.forEach((item) => {
        self.Regulations.Translates.push(item);
      });
      self.translatemodal = false;
    },
    addtransliteTab() {
      var self = this;
      if (
        self.translaterow.languageid === 0 ||
        self.translaterow.languageid === undefined ||
        self.translaterow.languageid === null
      ) {
        this.$notification(
          this.$t("languageidNotSelect"),
          this.$t("Error"),
          "danger"
        );
      } else if (
        self.translaterow.translatetext === "" ||
        self.translaterow.translatetext === undefined ||
        self.translaterow.translatetext === null
      ) {
        this.$notification(
          this.$t("translatetextNotSelect"),
          this.$t("Error"),
          "danger"
        );
      } 
      else {
        // var dublikate = false;
        // self.translatelistTab.forEach((item) => {
        //   if (item.languageid === self.translaterow.languageid) {
        //     this.$notification(
        //       this.$t("dublikate"),
        //       this.$t("Error"),
        //       "danger"
        //     );
        //     dublikate = true;
        //   }
        // });
        // if (!dublikate) {
          self.translaterow.languagename = self.LanguageList.filter(
            (item) => item.id === self.translaterow.languageid
          )[0].fullname;
          self.translaterow.columnname = self.translatebyname;
          self.translatelistTab.push(self.translaterow);
          self.translaterow = {
            tableid: 0,
            tablerowid: 0,
            languageid: 0,
            languagename: "",
            columnname: "",
            translatetext: "",
          };
        // }
      }
      self.Regulations.Translates = self.Regulations.Translates.filter(
        (x) => x.columnname !== self.translatebyname
      );
      self.translatelistTab.forEach((item) => {
        self.Regulations.Translates.push(item);
      });
    },
    SaveTranslateTab() {
      var self = this;
      self.Regulations.Translates = self.Regulations.Translates.filter(
        (x) => x.columnname !== self.translatebyname
      );
      self.translatelistTab.forEach((item) => {
        self.Regulations.Translates.push(item);
      });
      // self.translatemodal = false;
    },
    rowClass(item, type) {
      if (item.Status === 3) return "d-none";
    },
    Edit(item) {
      if (item.Status == 0) {
        item.Status = 2;
      }
      this.editedIndex1 = this.Regulations.Tables.indexOf(item);
      this.tabrow = Object.assign({}, item);
      this.ModalShow = true;
    },
    DeleteRow(item) {
      item.Status = 3;
    },
    AddRow() {
      if (this.editedIndex1 > -1) {
        Object.assign(this.Regulations.Tables[this.editedIndex1], this.tabrow);
      } else {
        this.Regulations.Tables.push(this.tabrow);
      }
      this.ModalShow = false;
    },
    OpenModal() {
      this.ModalShow = true;
      this.tabrow = {
        id: 0,
        ownerid: 0,
        text: "",
        Status: 1,
      };
      this.editedIndex1 = -1;
    },
    check() {
      if (
        this.Regulations.headertext === 0 ||
        this.Regulations.headertext === null ||
        this.Regulations.headertext === undefined ||
        this.Regulations.headertext === ""
      ) {
        this.$notification(this.$t("headertextNotSelected"), "danger");
        return false;
      }
      if (
        this.Regulations.stateid === 0 ||
        this.Regulations.stateid === null ||
        this.Regulations.stateid === undefined ||
        this.Regulations.stateid === ""
      ) {
        this.$notification(this.$t("stateNotSelected"), "danger");
        return false;
      }

      return true;
    },
    SaveData() {
      // console.log(this.content);
      // console.log(this.Regulations);
      if (!this.check()) {
        return false;
      }
      RegulationsService.Update(this.Regulations)
        .then((res) => {
          this.$notification(this.$t("SaveSuccess"), "success");
          this.$router.push({ name: `Regulations` });
        })
        .catch((err) => {
          this.$notification(this.$t(err.response.data.error), "danger");
        });
    },
  },
};
</script>

<style>
.iconStyle {
  transform: scale(1.5);
}
</style>
